import axios from "axios";
import {
    URLAPI,
    EMPLOYEE_FORM_PATH,
    ITEM_EMPLOYEE_FORM_PATH,
    FORM_UPDATE_PATH,
    FORM_FIELD_UPDATE_PATH,
    SEND_FORM_EMPLOYEE_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_employee_form: {
        data: [],
        status: 0,
        message: {},
    },
    _update_form: {
        data: {},
        status: 0,
        message: {},
    },
    _send_form_employee: {
        data: {},
        status: 0,
        message: {},
    },
    _update_form_field: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_EMPLOYEE_FORM = "GET_ALL_EMPLOYEE_FORM";
export const UPDATE_FORM = "UPDATE_FORM";
export const UPDATE_FORM_FIELD = "UPDATE_FORM_FIELD";
export const SEND_FORM_EMPLOYEE = "SEND_FORM_EMPLOYEE";


export const form_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_EMPLOYEE_FORM:
            return {
                ...state,
                _get_all_employee_form: action.payload,
            };
        case UPDATE_FORM:
            return {
                ...state,
                _update_form: action.payload,
            };
        case UPDATE_FORM_FIELD:
            return {
                ...state,
                _update_form_field: action.payload,
            };
        case SEND_FORM_EMPLOYEE:
            return {
                ...state,
                _send_form_employee: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


export const get_all_employee_form = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${EMPLOYEE_FORM_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_EMPLOYEE_FORM,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_EMPLOYEE_FORM,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_EMPLOYEE_FORM,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener los formularios",
                },
            });
        }
    }
}


export const update_form = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${FORM_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_FORM,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_FORM,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_FORM,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const update_form_field = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${FORM_FIELD_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_FORM_FIELD,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_FORM_FIELD,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_FORM_FIELD,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const send_form_employee = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${SEND_FORM_EMPLOYEE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: SEND_FORM_EMPLOYEE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: SEND_FORM_EMPLOYEE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: SEND_FORM_EMPLOYEE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const searchEmployeeForm = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${ITEM_EMPLOYEE_FORM_PATH}${paramsUrl}`, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  };

export const clear_status_form = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}